// for common data
export const COMMON_VALUES = 'COMMON_VALUES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SWITCH_LANGUAGE = 'SWITCH_LANGUAGE'
export const SET_MEMBERSHIP = 'SET_MEMBERSHIP'
export const SOCKET_MODAL = 'SOCKET_MODAL'
export const SEARCH_JUSTGIVING_CHARITY = 'SEARCH_JUSTGIVING_CHARITY'
